import React from 'react';
import { hotelData } from '../data/hotelData';
import RoomCard from './RoomCard';
import { motion, useScroll, useTransform } from 'framer-motion';

const Rooms = () => {
  return (
    <section id="rooms" className="py-24 bg-white relative overflow-hidden">
      <div className="container-custom relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-10">
          <div className="max-w-2xl">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="flex items-center gap-4 mb-4"
            >
              <div className="w-12 h-[1px] bg-orange-500" />
              <span className="text-orange-500 text-[10px] tracking-[0.4em] uppercase font-bold">
                Luxury Accommodations
              </span>
            </motion.div>
            
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="text-5xl md:text-6xl font-serif text-luxury-black mb-6 leading-tight"
            >
              Our Rooms & Suites
            </motion.h2>
            
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-gray-500 text-lg font-light leading-relaxed max-w-xl"
            >
              Experience refined comfort in our meticulously designed suites, where modern elegance meets urban tranquility.
            </motion.p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <button className="text-luxury-black text-[10px] tracking-[0.3em] uppercase font-bold border-b border-luxury-black pb-2 hover:text-orange-500 hover:border-orange-500 transition-all">
              View All Suites
            </button>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12">
          {hotelData.rooms.map((room, index) => (
            <div key={room.id}>
              <RoomCard room={room} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Rooms;
